import React from "react";
import classNames from "classnames";
import { Modal as ModalBase, ModalProps as BaseModalProps } from "antd";
import { BemHelper } from "../../utils";
import { CloseIcon } from "@/icons/primary";

export type ModalProps = BaseModalProps & {
  disableFooter?: boolean;
  disableBorder?: boolean;
};

const bem = new BemHelper("modal");

export const Modal: React.FC<ModalProps> = ({
  disableFooter,
  disableBorder,
  footer,
  children,
  ...props
}) => {
  return (
    <ModalBase
      footer={disableFooter ? <></> : footer}
      className={classNames(
        bem.block(),
        disableFooter && bem.modifier("footer-disabled"),
        disableBorder && bem.modifier("border-disabled"),
        props.className,
      )}
      closeIcon={props.closeIcon || <CloseIcon />}
      {...props}
    >
      {children}
    </ModalBase>
  );
};
